import React, {Fragment} from 'react';
import {connect} from "react-redux";
import isEmpty from 'lodash/isEmpty';

import CheckBox from "../../PageLayout/CheckBox";
import {setBundleQuantities} from "./NewFeatureActions";
import {fixFeatureNumberValue} from "../../FeaturesSetup/featuresFunctions";
import TextInput from "../../Generic/textInput";

const loaderStyles = {
  width: "100%",
  height: "100%",
  margin: 0,
  padding: 0,
  position: "absolute",
  zIndex: 2000
}

const filtersOptions = {
  allFilterOptions: "+Filters",
  materialFilterOptions: "Material",
  sortOptions: "sortOptions",
  colorFilterOptions: "Color",
};

const filterGroupHasBundleProducts = (featureGroup, bundledFeatures, newFeatureOverlay) => {
  if (!bundledFeatures || !Array.isArray(bundledFeatures.features) || !bundledFeatures.features.length) {
    return false;
  }
  const allFeatures = newFeatureOverlay.getGroupsFeatures(featureGroup);
  if (!Array.isArray(allFeatures) || !allFeatures.length) {
    return false;
  }
  return bundledFeatures.features.some(dbFeatureId => {
    return allFeatures.some(feature => {
      return Array.isArray(feature.id) ? feature.id.includes(dbFeatureId) : feature.id === dbFeatureId
    });
  })
};

const NewFeatureOverlayBundledFeaturesStep = (props) => {

  const {newFeatureOverlay, setBundleQuantities, bundledFeaturesQuantities} = props;
  const {bundledFeatures, relatedLoading} = newFeatureOverlay.state;
  const {unfilteredFeatureGroups} = newFeatureOverlay.props;

  const onSearchInputChange = (event) => {
    newFeatureOverlay.setBfState({productFilter: event.target.value})
  }

  const onFiltersClick = (optionSet = "") => {
    if ((optionSet !== "sortOptionsVisible") && isEmpty(bundledFeatures[optionSet])) {
      return
    }
    let objToSet = {};
    Object.keys(filtersOptions).forEach(prop => {
      objToSet[prop] = optionSet === prop;
    })
    newFeatureOverlay.setBfState(objToSet);
  }

  const bundleList = bundledFeatures.activeGroup
    ? newFeatureOverlay.applyProductSort(newFeatureOverlay.applyProductFilters(newFeatureOverlay.getGroupsFeatures(bundledFeatures.activeGroup)))
    : [];

  const onQuantityInputChange = (value, feature) => {
    setBundleQuantities(Object.assign({}, bundledFeaturesQuantities, {
      [feature.id]: +value
    }))
  }

  return (
    <div className="feature-creation__content">
      <div className="fc-filter fc-filter--bundled">
        <div className="fc-cat">
          <span className="generic-popup-title">Product Groups</span>
          {relatedLoading ? (
            <div style={loaderStyles}>
              <div className="ui-loader"/>
            </div>
          ) : null}
          <ul className="fc-cat__list">
            {unfilteredFeatureGroups && unfilteredFeatureGroups.map && unfilteredFeatureGroups.map((group, groupIndex) => {
              const hasSomethingSelected = filterGroupHasBundleProducts(
                group,
                bundledFeatures,
                newFeatureOverlay
              );
              return (
                <li className={"fc-cat__list-item"
                  + (hasSomethingSelected ? " fc-cat__list-item--has-filters" : "")
                  + (group === bundledFeatures.activeGroup ? " fc-cat__list-item--active" : "")}
                    key={group.name + groupIndex}
                    onClick={() => newFeatureOverlay.setBfState({activeGroup: group}, newFeatureOverlay.refreshFilterIcons)}>
                  {group.name}
                </li>
              )
            })}
          </ul>
        </div>
        <div className="fc-filters fc-filters--with-header">
          <div className="fc-filters__header">
            <div className="fc-filters__header-input">
              <input className="generic-popup-textbox"
                     placeholder="search"
                     value={bundledFeatures.productFilter}
                     onChange={onSearchInputChange}/>
            </div>
            <div className="fc-filters__header-buttons">
              <span className={"ui-icon-filter ui-icon-filter--properties"
                + (bundledFeatures.allFilterOptionsVisible ? ' ui-icon-filter--active' : '')
                + (isEmpty(bundledFeatures.allFilterOptions) ? ' disabled' : '')}
                    onClick={() => onFiltersClick("allFilterOptionsVisible")}>
                +Filters
              </span>
              <span className={"ui-icon-filter ui-icon-filter--material"
                + (bundledFeatures.materialFilterOptionsVisible ? ' ui-icon-filter--active' : '')
                + (isEmpty(bundledFeatures.materialFilterOptions) ? ' disabled' : '')}
                    onClick={() => onFiltersClick("materialFilterOptionsVisible")}>
                Material
              </span>
              <span className={"ui-icon-filter ui-icon-filter--" + bundledFeatures.productSortBy.toLowerCase()
                + (bundledFeatures.sortOptionsVisible ? ' ui-icon-filter--active' : '')}
                    onClick={() => onFiltersClick("sortOptionsVisible")}>
                {bundledFeatures.productSortBy}
              </span>
              <span className={"ui-icon-filter ui-icon-filter--material"
                + (bundledFeatures.colorFilterOptionsVisible ? ' ui-icon-filter--active' : '')
                + (isEmpty(bundledFeatures.colorFilterOptions) ? ' disabled' : '')}
                    onClick={() => onFiltersClick("colorFilterOptionsVisible")}>
                Color
              </span>
            </div>
          </div>
          <div className="fc-filters__sub-header">
            <CheckBox type="tiny"
                      checked={bundledFeatures.checkAllFeatures}
                      text="All Products"
                      disabled={!bundledFeatures.activeGroup}
                      onChecked={() => newFeatureOverlay.allProductsClicked(bundledFeatures)}
            />
          </div>
          {bundledFeatures.activeGroup ? (
            <Fragment>
              {isEmpty(bundledFeatures.activeGroup.features || bundledFeatures.activeGroup.values) ? (
                <div className="fc-filters__text">
                  <div className="fc-installation__empty">
                    Product Group has no Products, it should not have been visible
                  </div>
                </div>
              ) : (
                <ul className="fc-filters__list">
                  {bundleList.map(feature => {
                    const checked = bundledFeatures.features.some(sf => feature.id.indexOf(sf) !== -1);
                    return (
                      <li className="fc-filters__list-item fc-filters__list-item--bundled" key={feature.id}>
                        <CheckBox type="tiny"
                                  className={"flex flex--center"}
                                  text={feature.originalNakedName || feature.name}
                                  checked={checked}
                                  onChecked={() => newFeatureOverlay.toggleFeature(feature.id, feature, bundledFeatures, newFeatureOverlay.setBfState)}
                        />
                        {checked ? (
                          <div className="fc-filters__list-item-input flex flex--center">
                            <span>Qty:</span>
                            <TextInput className={`generic-popup-textbox generic-popup-textbox--in-list ${feature.priceLocked ? "generic-popup-textbox--disabled" : ""}`}
                                       placeholder=""
                                       onChange={(value) => onQuantityInputChange(value, feature)}
                                       maxLength={9999}
                                       disabled={feature.priceLocked}
                                       numberInput={true}
                                       value={fixFeatureNumberValue(bundledFeaturesQuantities[feature.id])} />
                          </div>
                        ) : null}
                      </li>
                    )
                  })}
                </ul>
              )}
            </Fragment>
          ) : (
            <div className="fc-filters__text">
              <div className="fc-installation__empty">
                Select a Product Group
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {bundledFeaturesQuantities} = store.newFeature;

  return {
    bundledFeaturesQuantities,
  };
};

const mapDispatchToProps = {
  setBundleQuantities,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewFeatureOverlayBundledFeaturesStep)
